import React from "react";
import {useAuthentication} from "./AuthProvider";
import authService from "../auth/services/auth-service";

export const RequireAuth = ({
                                 children
                             }: { children: JSX.Element }) => {
    let auth = useAuthentication();

    if (!auth.isAuthenticated()) {
        authService.signinRedirect();
        return <span>Please wait while you are redirected to login...</span>;
    }

    return children;
};
